import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import cx from 'classnames'
import useStyles from './styles'

const CustomSelectV2 = ({ label, value, options = [], onChange = () => {}, background = '#fff', className = '' }) => {
  const classes = useStyles()

  const handleChange = (event) => {
    onChange(event.target.value)
  }

  return (
    <Box className={cx(classes.select, className)}>
      <FormControl className={classes.select} fullWidth>
        <InputLabel className={classes.labelStyle} id="demo-simple-select-label">
          {label}
        </InputLabel>
        <Select
          IconComponent={KeyboardArrowDownIcon}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={handleChange}
          MenuProps={{
            PaperProps: {
              className: classes.select_menu,
              style: { '--bg': background },
            },
          }}
        >
          {options.map((option) => (
            <MenuItem value={option?.value} key={option?.value}>
              {option?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default CustomSelectV2
